import { ISpecs } from 'app/models/specs/specs';
import { ISupplier } from 'app/models/supplier';

export const SET_SPECS = '[Settings] Set Specs';
export const SET_SUPPLIER = '[Settings] Set Supplier';

export interface ISetSpecs {
  type: typeof SET_SPECS;
  payload: { specs: ISpecs };
}

export interface ISetSupplier {
  type: typeof SET_SUPPLIER;
  payload: { supplierDetails: ISupplier | null };
}

export const setSpecs = (specs: ISpecs): ISetSpecs => {
  return {
    type: SET_SPECS,
    payload: { specs },
  };
};

export const setSupplier = (supplierDetails: ISupplier | null): ISetSupplier => {
  return {
    type: SET_SUPPLIER,
    payload: { supplierDetails },
  };
};

export type SettingsActions = ISetSpecs | ISetSupplier;
